module.exports = __webpack_public_path__ + "static/media/files_and_folder.eb772408.png";